import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable, ReplaySubject } from 'rxjs';

export type AlertType = 'success' | 'error';

export interface AlertMessagePayload {
  type: AlertType;
  text?: string;
  i18nKey?: string;
  i18nParams?: Record<string, unknown>;
}

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  private subject = new ReplaySubject<AlertMessagePayload | null | undefined>(1);
  private keepAfterNavigationChange = false;

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
          if (event instanceof NavigationStart) {
              if (this.keepAfterNavigationChange) {
                this.keepAfterNavigationChange = false;
              } else {
                this.subject.next(undefined);
              }
          }
      });
  }

  success(message: string, keepAfterNavigationChange = false) {
      this.emitAlert({ type: 'success', text: message }, keepAfterNavigationChange);
  }

  error(message: string, keepAfterNavigationChange = false) {
      this.emitAlert({ type: 'error', text: message }, keepAfterNavigationChange);
  }

  successKey(i18nKey: string, keepAfterNavigationChange = false, i18nParams?: Record<string, unknown>) {
      this.emitAlert({ type: 'success', i18nKey, i18nParams }, keepAfterNavigationChange);
  }

  errorKey(i18nKey: string, keepAfterNavigationChange = false, i18nParams?: Record<string, unknown>) {
      this.emitAlert({ type: 'error', i18nKey, i18nParams }, keepAfterNavigationChange);
  }

  getMessage(): Observable<AlertMessagePayload | null | undefined> {
      return this.subject.asObservable();
  }

  clear() {
    this.subject.next(null);
  }

  private emitAlert(alert: AlertMessagePayload, keepAfterNavigationChange: boolean): void {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.subject.next(alert);
  }

}
